<script>
import { mapGetters } from 'vuex';
import ReportSearchBlock from '../ReportSearchBlock';

export default {
  name: 'ReportGroups',
  mixins: [ReportSearchBlock],
  data() {
    return {
      placeholder: 'Filter by Group',
    };
  },

  methods: {
    setInput(val) {
      this.$emit('input', val);
    },
  },

  computed: {
    ...mapGetters(['groups']),

    getOptions() {
      return this.groups.map((group) => {
        return {
          label: group.name,
          value: group.id,
        };
      });
    },
  },
};
</script>
